import { Panel } from "@/components/atoms";
import { ExternalSupplierNavigation } from "../../../common/ExternalSupplierNavigation";
import { ExternalSupplierHeader } from "./sections/ExternalSupplierHeader";
import { ExternalSupplierDetails } from "./sections/ExternalSupplierDetails";

export const ProfilePanel = () => {
  return (
    <div className="flex gap-3">
      <ExternalSupplierNavigation />
      <Panel>
        <ExternalSupplierHeader />
        <ExternalSupplierDetails />
      </Panel>
    </div>
  );
};
